/**
 * Chat echo for the activity, ritual, and event member step.
 * With nobody selected the quorum clause is omitted.
 */
export const formatParticipantsSelectionEcho = (
  memberCount: number,
  minConfirmedMembers: number | null | undefined,
): string => {
  if (memberCount <= 0) {
    return "Selecionados 0 participante(s)";
  }
  return `Selecionados ${memberCount} participante(s) — quórum ${minConfirmedMembers}`;
};

/**
 * Empty `memberIds` always submit `null`. A non-empty selection keeps the
 * quorum the picker (or the caller) already resolved.
 */
export const quorumForMemberSelection = (
  memberIds: readonly string[],
  minConfirmedMembers: number | null | undefined,
): number | null | undefined =>
  memberIds.length === 0 ? null : minConfirmedMembers;
